import React,{Fragment} from 'react';

import Button from 'components/Button';
import GoogleButton from 'components/GoogleButton';
import Loader from 'components/Loader';
import alertIcon from './alert-icon.svg';
import { useDispatch } from 'react-redux';
import { toggleFormModal } from '../../actions';
 
const App = (props) =>{
    const dispatch = useDispatch();
    const installationProblem = props.app.tokenInvalid || props.app.migrateTo;
    const onInstall = () => {
        props.app.preInstall ? 
            dispatch(toggleFormModal(props.app.ID, 'install')) : 
            props.onInstallApp(props.app)
    }
    const renderInstallButton = () => {
        const isGoogle = ['googleDev', 'google'].includes(props.app.source)
        const isAuthed = props.authenticated 
        if(isGoogle && isAuthed) return <GoogleButton onClick={onInstall} logo={props.app.logoGraphic} />
        return (
            <Button onClick={onInstall} styling="apps-outlined">
                {isAuthed ? 'Install' : 'Sign In To Install'}
            </Button>
        )
    }
    return (
        <div className="integration-app">
            <div className="app-block">
                <div className="app-info">
                    {installationProblem ? <img src={alertIcon} alt="Alert" className="app-alert"/> : null}
                    <img className="app-logo" src={props.app.logoGraphic}/>
                    <h5>{props.app.name}{props.app.beta ? <span className="beta">BETA</span> : null}</h5>
                    {props.app.organisation ? <p className="bold">{`${props.app.organisationLabel || 'Organisation'}: ${props.app.organisation}`}</p> : null}
                    <p className="left">{props.app.description}</p>
                </div>
                <div className="button-container">
                    {props.app.appInstallationID ?
                        <Fragment>
                            {installationProblem ?
                                <Button onClick={()=>props.onResetApp(props.app)} styling="apps-outlined-reset">{props.app.resetting ? <Loader type="2" size="16px"/> : 'Reset'}</Button> :
                                props.app.configuration && Object.keys(props.app.configuration.settings).length > 0 ? <Button onClick={() => dispatch(toggleFormModal(props.app.ID,'configure'))} styling="apps-outlined">Configure</Button> : null}
                                <Button onClick={()=>props.onUninstallApp(props.app.appInstallationID,props.app.ID)} styling="apps-outlined-uninstall">{props.app.uninstalling ? <Loader type="2" size="16px"/> : 'Uninstall'}</Button>
                        </Fragment> :
                        <Fragment> {props.app.link ? <a href={props.app.link} target="_blank"><Button styling="apps-outlined external">Install</Button></a> : renderInstallButton()}
                        </Fragment>}
                </div>
            </div>
        </div>
    )
}

export default App;


// WEBPACK FOOTER //
// ./src/scenes/Apps/App.js